/**
 * Structured pipeline timing logs for queueing-delay investigation.
 * Filter browser console / Cloud Functions logs with: STARLING_PIPELINE
 */

const PREFIX = '[STARLING_PIPELINE]';

function nowIso() {
  return new Date().toISOString();
}

/** @param {string} event @param {Record<string, unknown>} [detail] */
export function logPipelineDiagnostic(event, detail = {}) {
  const prodEnabled = process.env.REACT_APP_VOLUGRAPH_PIPELINE_LOGS === '1';
  if (process.env.NODE_ENV !== 'development' && !prodEnabled) return;
  const payload = { event, at: nowIso(), ...detail };
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-console
    console.info(PREFIX, payload);
  } else {
    // eslint-disable-next-line no-console
    console.info(`${PREFIX} ${JSON.stringify(payload)}`);
  }
}

/** Per-capture timeline helper (frontend). */
export function createPipelineTimeline(captureId) {
  const startedAt = Date.now();
  const marks = [];
  return {
    mark(label, extra = {}) {
      const elapsedMs = Date.now() - startedAt;
      marks.push({ label, elapsedMs, ...extra });
      logPipelineDiagnostic(label, { captureId, elapsedMs, ...extra });
    },
    marks,
  };
}
